
const SlantBottom = () => {
  return (
    <div className={`w-full max-w-full`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1280 100"
        preserveAspectRatio="none"
        style={{ marginTop: `-1px` }}
      >
        <path fill="#f8f8f8" d="M1280,0V100L0,0Z" />
      </svg>
    </div>
  )
}

const SlantTop = () => {
  return (
    <div className={`w-full max-w-full`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1280 122"
        preserveAspectRatio="none"
        style={{ marginBottom: `-1px` }}
      >
        <polygon
          fill="#f8f8f8"
          points="1232.52 118.51 0 20.37 0 28 0 122 1280 122 1232.52 118.51"
        />
        <polygon
          fill="#479ebc"
          points="1280 112 0 0 0 20.37 1232.52 118.51 1280 122 1280 112"
        />
      </svg>
    </div>
  )
}

export { SlantTop, SlantBottom }
